const processes = {};

const getProfilerState = (processType) => {
    const process = processes[processType];

    if (!process?.endTime) return;

    const duration = process.endTime - process.startTime;

    return {duration};
};

const start = (processType) => {
    processes[processType] = {startTime: Date.now(), endTime: null};
};

const stop = (processType) => {
    const process = processes[processType];

    if (!process) return;

    process.endTime = Date.now();

    return getProfilerState(processType);
};

export default {stop, start};
